module.exports = __webpack_public_path__ + "img/home-11.ea490572.png";